
































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { ReservationApi } from '../../models/NDVModalTabs.model';
import TabReservationsEdit from './TabReservationsEdit.vue';
import {
  PermisoAccion,
  codigoAccionesMenuItem as allActions,
} from '@/views/base/VariablesPermisos';
import { DataApi, FunctionParams } from '../../models/NDVBase.model';
import MenuItem from '@/components/MenuItem.vue';
import store from '@/store';

const { AgGridVue } = require('ag-grid-vue');
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  ColDef,
  ColumnApi,
  CellClickedEvent,
} from 'ag-grid-community';
import { actionsEvent } from '@/setup';

@Component({ components: { GridComponent: AgGridVue, TabReservationsEdit } })
export default class TabReservations extends Vue {
  @Prop({ required: true, default: [] }) data!: ReservationApi[];
  readonly funcionalidad: Funcionalidades = Funcionalidades.ModalNDVReservas;
  readonly codigoAccionesMenuItem = Object.values(allActions);

  columnApi: any = null;
  gridOptions: GridOptions = null;
  gridEvent: any = null;
  gridApi: GridApi = null;
  columnDefs: ColDef[] = [];
  listData: any = [];
  quickSearch: string = '';
  showEdit: boolean = false;
  data_to_edit: any = {};
  constructor() {
    super();

    this.columnDefs = this.colsGrid({
      fn: this.funcionalidad,
      allActions: this.codigoAccionesMenuItem,
    });
    actionsEvent.onEditar(this.handleEdit);
    this.gridOptions = {
      columnDefs: this.columnDefs,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      onGridReady: this.handleMainGridReady,
    };
  }
  handleEdit(params: { data: any }) {
    console.log('params', params);
    this.data_to_edit = params.data;
    this.showEdit = true;
  }
  handleCancel() {
    this.data_to_edit = {};
    this.showEdit = false;
  }
  handleMainGridReady(event: GridReadyEvent): void {
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    this.gridApi.setRowData(this.data);
    this.gridApi.setDomLayout('autoHeight');
  }

  private colsGrid({ fn, allActions }: FunctionParams): ColDef[] {
    console.log('this.data', this.data);
    const cols: ColDef[] = Object.keys(this.data[0])
      .filter(col => !['ndvnumero', 'STATUS', 'TOTAL_REGISTROS'].includes(col))
      .map(col => ({
        headerName: col,
        field: col,
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 220,
        minWidth: 100,
      }));

    cols.push({
      headerName: 'Acciones',
      sortable: false,
      resizable: true,
      filter: false,
      width: 120,
      minWidth: 120,
      maxWidth: 120,
      field: 'id',
      cellRendererFramework: MenuItem,
      cellRendererParams: (params: { data: DataApi }) => ({
        funcionalidad: fn,
        codigoAccionesMenuItem: allActions,
        usuario: store.state.user,
        data: params.data,
        contextoAccionReutilizable: ['Ver Anulación', 'backspace'],
      }),
      colId: 'params',
      rowDrag: false,
      pinned: 'right',
      lockVisible: true,
      suppressMovable: true,
      suppressMenu: true,
      getQuickFilterText: () => '',
    });
    return cols;
  }

  handleSearch() {
    this.gridApi.setQuickFilter(this.quickSearch);
    this.gridApi.setDomLayout('autoHeight');
  }
  beforeDestroy() {
    console.log('El componente TabReservations se está cerrando');
    this.$emit('cerrar');
  }
}
